import React from 'react';

import { ReactComponent as DhlLogo } from '../resources/images/dhl-logo.svg';

 const Header = () => {
 return (
  <div className="Header">
    <div style={{flex: 0.1}} />
    <DhlLogo className="HeaderLogo"/>
    <div style={{flex: 0.1}}/>
  </div>
 );
 };

export default Header;
